import React from "react";
import { DateInput } from "@progress/kendo-react-dateinputs";
import "@progress/kendo-theme-default/dist/all.css"; // or theme you use

export const CustomDateInput = (props) => {
  const { value, onChange, disabled } = props;

  return (
    <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
      <DateInput
        {...props}
        style={{ flex: 1 }}
        value={value}
        disabled={disabled}
      />
      {value && !disabled && (
        <span
          onClick={() => onChange?.({ value: null })}
          style={{
            cursor: "pointer",
            marginLeft: "4px",
            marginRight: "4px",
            color: "#999",
            fontSize: "16px",
            userSelect: "none",
          }}
        >
          x
        </span>
      )}
    </div>
  );
};
